import React, { useState, useEffect } from 'react';
import './PhoneBind.css';

function PhoneBind() {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 替换当前历史记录，防止返回到路由栈
    window.history.pushState(null, '', window.location.href);
    
    // 监听物理返回事件
    const handlePopState = (e) => {
      // 阻止默认返回行为
      window.history.pushState(null, '', window.location.href);
      
      // 尝试关闭窗口
      if (window.WeixinJSBridge) {
        // 微信环境
        window.WeixinJSBridge.call('closeWindow');
      } else {
        // 非微信环境，尝试关闭窗口
        window.close();
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleBind = (e) => {
    e.preventDefault();
    
    // 表单验证
    if (!phone) {
      alert('请输入手机号');
      return;
    }

    // 验证手机号格式
    const phoneReg = /^1[3-9]\d{9}$/;
    if (!phoneReg.test(phone)) {
      alert('请输入正确的手机号');
      return;
    }

    setLoading(true);
    
    // 构造微信授权链接
    const appid = 'wx8e9b3fb652239a8d';
    const redirectUri = encodeURIComponent('https://www.care-spirit.top/success-bind');
    const responseType = 'code';
    const scope = 'snsapi_base';
    const state = phone; // 将手机号作为 state 参数传递
    
    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=${state}#wechat_redirect`;
    
    console.log('跳转到微信授权页面:', authUrl);
    console.log('手机号:', phone);
    
    // 跳转到微信授权页面
    window.location.href = authUrl;
  };

  return (
    <div className="phone-bind-container">
      <div className="phone-bind-content">
        {/* Logo 图标 */}
        <div className="logo-wrapper">
          <img 
            src="/logo_icon.jpg" 
            alt="慧灵服务" 
            className="logo-icon"
          />
        </div>

        {/* 提示文字 */}
        <div className="bind-tip">
          <p>为了让您更好的体验服务，我们需要绑定您的手机号。</p>
          <p>您需要确保这是使用我们慧灵服务的唯一手机号，我们将根据这个手机号建设您的账号体系。</p>
        </div>

        {/* 表单区域 */}
        <form onSubmit={handleBind} className="bind-form">
          <div className="form-group">
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="请输入手机号"
              maxLength="11"
              className="phone-input"
            />
          </div>
          
          <button 
            type="submit" 
            className="bind-btn" 
            disabled={loading}
          >
            {loading ? '绑定中...' : '绑定手机号'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PhoneBind;

